/**
 * Filtrous Product Page JS
 * Gallery, variant selection, quantity, add-to-cart, tabs.
 * No jQuery. No Empire dependencies.
 */
(function () {
  'use strict';

  var productData;
  try {
    var jsonEl = document.getElementById('filtrous-product-json');
    if (jsonEl) productData = JSON.parse(jsonEl.textContent);
  } catch (e) {
    // No product data available
  }

  /* ========================================
     Gallery
     ======================================== */
  function initGallery() {
    var mainImage = document.querySelector('[data-main-image]');
    var thumbnails = document.querySelectorAll('[data-thumb-index]');
    if (!mainImage || thumbnails.length === 0) return;

    var img = mainImage.querySelector('img');
    if (!img) return;

    // Thumbnail click
    thumbnails.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var src = this.getAttribute('data-image-src');
        var zoomSrc = this.getAttribute('data-zoom-src');
        if (!src) return;

        img.src = src;
        img.setAttribute('data-zoom-src', zoomSrc || src);

        thumbnails.forEach(function (t) { t.classList.remove('fph__thumb--active'); });
        this.classList.add('fph__thumb--active');
      });
    });

    // Zoom on hover (desktop only)
    if (mainImage.hasAttribute('data-enable-zoom') && !isTouchDevice()) {
      mainImage.addEventListener('mousemove', function (e) {
        var rect = mainImage.getBoundingClientRect();
        var x = ((e.clientX - rect.left) / rect.width) * 100;
        var y = ((e.clientY - rect.top) / rect.height) * 100;
        img.style.transformOrigin = x + '% ' + y + '%';
        mainImage.classList.add('fph__main-image--zoomed');
      });

      mainImage.addEventListener('mouseleave', function () {
        mainImage.classList.remove('fph__main-image--zoomed');
        img.style.transformOrigin = '';
      });
    }

    // Mobile swipe
    if (isTouchDevice() && thumbnails.length > 1) {
      var startX = 0;
      var currentIndex = 0;

      mainImage.addEventListener('touchstart', function (e) {
        startX = e.touches[0].clientX;
      }, { passive: true });

      mainImage.addEventListener('touchend', function (e) {
        var diff = startX - e.changedTouches[0].clientX;
        if (Math.abs(diff) < 40) return;

        if (diff > 0 && currentIndex < thumbnails.length - 1) {
          currentIndex++;
        } else if (diff < 0 && currentIndex > 0) {
          currentIndex--;
        }

        thumbnails[currentIndex].click();
      }, { passive: true });
    }
  }

  /* ========================================
     Variant Selection
     ======================================== */
  function initVariants() {
    if (!productData || !productData.variants) return;

    var optionBtns = document.querySelectorAll('[data-option-value]');
    var variantInput = document.querySelector('[data-variant-id]');
    if (optionBtns.length === 0 || !variantInput) return;

    // Build selected options from current variant
    var selectedOptions = [];
    var currentVariant = productData.variants.find(function (v) {
      return v.id === parseInt(variantInput.value);
    });
    if (currentVariant) {
      selectedOptions = [currentVariant.option1, currentVariant.option2, currentVariant.option3].filter(Boolean);
    }

    optionBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var group = this.closest('[data-option-group]');
        if (!group) return;
        var index = parseInt(group.getAttribute('data-option-group'));
        var value = this.getAttribute('data-option-value');
        selectedOptions[index] = value;

        // Update active state in this group
        group.querySelectorAll('[data-option-value]').forEach(function (b) {
          b.classList.remove('fph__option-btn--active');
        });
        this.classList.add('fph__option-btn--active');

        // Update option display text
        var display = document.querySelector('[data-option-display="' + index + '"]');
        if (display) display.textContent = value;

        // Find matching variant
        var variant = findVariant(selectedOptions);
        if (variant) {
          updateVariant(variant);
        }
      });
    });
  }

  function findVariant(options) {
    return productData.variants.find(function (v) {
      var match = true;
      if (options[0] && v.option1 !== options[0]) match = false;
      if (options[1] && v.option2 !== options[1]) match = false;
      if (options[2] && v.option3 !== options[2]) match = false;
      return match;
    });
  }

  function updateVariant(variant) {
    // Hidden input
    var input = document.querySelector('[data-variant-id]');
    if (input) input.value = variant.id;

    // Price
    var priceEl = document.querySelector('[data-price]');
    var compareEl = document.querySelector('[data-compare-price]');
    var saveEl = document.querySelector('[data-price-save]');
    var unitEl = document.querySelector('[data-unit-price]');
    var priceWrapper = document.querySelector('[data-price-wrapper]');

    if (priceEl) {
      priceEl.textContent = formatMoney(variant.price);
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        priceEl.classList.add('fph__price-current--sale');
        if (!compareEl) {
          compareEl = document.createElement('span');
          compareEl.className = 'fph__price-compare';
          compareEl.setAttribute('data-compare-price', '');
          priceEl.after(compareEl);
        }
        compareEl.textContent = formatMoney(variant.compare_at_price);
        compareEl.style.display = '';

        var savePercent = Math.round(((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100);
        if (!saveEl) {
          saveEl = document.createElement('span');
          saveEl.className = 'fph__price-save';
          saveEl.setAttribute('data-price-save', '');
          compareEl.after(saveEl);
        }
        saveEl.textContent = 'Save ' + savePercent + '%';
        saveEl.style.display = '';
      } else {
        priceEl.classList.remove('fph__price-current--sale');
        if (compareEl) compareEl.style.display = 'none';
        if (saveEl) saveEl.style.display = 'none';
      }
    }

    // Unit price
    if (unitEl && productData.metafields) {
      // Unit price recalculation would need pack_qty from metafields
      // For now, hide if variant changes significantly
    }

    // SKU
    var skuContainer = document.querySelector('[data-sku]');
    var skuEl = skuContainer ? skuContainer.querySelector('span') : null;
    if (skuEl) {
      skuEl.textContent = variant.sku || '';
      skuContainer.style.display = variant.sku ? '' : 'none';
    }

    // Specs tab SKU
    var specsSku = document.querySelector('[data-specs-sku]');
    if (specsSku) {
      specsSku.textContent = variant.sku || '';
    }

    // ATC button — show Pre-order when out of stock (regardless of policy)
    var atcBtn = document.querySelector('[data-atc-btn]');
    var atcText = document.querySelector('[data-atc-text]');
    if (atcBtn && atcText) {
      var isPreorder = !variant.available || (variant.inventory_quantity != null && variant.inventory_quantity <= 0);
      atcBtn.disabled = false;
      if (isPreorder) {
        atcBtn.classList.add('fn-card__atc-btn--preorder');
        atcText.textContent = 'Pre-order';
      } else {
        atcBtn.classList.remove('fn-card__atc-btn--preorder');
        atcText.textContent = 'Add to Cart';
      }
    }

    // Update gallery image if variant has one
    if (variant.featured_image) {
      var mainImg = document.querySelector('[data-main-image] img');
      if (mainImg) {
        // Find the matching thumbnail and click it
        var thumbs = document.querySelectorAll('[data-thumb-index]');
        thumbs.forEach(function (thumb) {
          var thumbSrc = thumb.getAttribute('data-image-src');
          if (thumbSrc && variant.featured_image.src && thumbSrc.indexOf(variant.featured_image.product_id) > -1) {
            thumb.click();
          }
        });
        // Direct image update as fallback
        if (variant.featured_image.src) {
          mainImg.src = variant.featured_image.src;
        }
      }
    }

    // URL update
    var url = new URL(window.location);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url);
  }

  /* ========================================
     Quantity
     ======================================== */
  function initQuantity() {
    var qtyBtns = document.querySelectorAll('[data-qty-action]');
    qtyBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var input = document.querySelector('[data-qty-input]');
        if (!input) return;
        var val = parseInt(input.value) || 1;
        var action = this.getAttribute('data-qty-action');

        if (action === 'increase') {
          input.value = val + 1;
        } else if (action === 'decrease' && val > 1) {
          input.value = val - 1;
        }
      });
    });
  }

  /* ========================================
     Add to Cart (AJAX)
     ======================================== */
  function initAddToCart() {
    var form = document.querySelector('[data-product-form]');
    if (!form) return;

    form.addEventListener('submit', function (e) {
      e.preventDefault();

      var atcBtn = form.querySelector('[data-atc-btn]');
      var atcText = form.querySelector('[data-atc-text]');
      if (!atcBtn || atcBtn.disabled) return;

      var variantId = form.querySelector('[data-variant-id]').value;
      var quantity = form.querySelector('[data-qty-input]');
      var qty = quantity ? parseInt(quantity.value) || 1 : 1;

      // Loading state
      var originalText = atcText.textContent;
      atcText.textContent = 'Adding...';
      atcBtn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          items: [{ id: parseInt(variantId), quantity: qty }]
        })
      })
        .then(function (res) {
          if (!res.ok) throw new Error('Add to cart failed');
          return res.json();
        })
        .then(function () {
          // Success feedback
          atcText.textContent = 'Added!';
          atcBtn.classList.add('fph__atc--added');

          // Update cart count in header
          updateCartCount();

          setTimeout(function () {
            atcText.textContent = originalText;
            atcBtn.disabled = false;
            atcBtn.classList.remove('fph__atc--added');
          }, 2000);
        })
        .catch(function () {
          atcText.textContent = 'Error — Try Again';
          setTimeout(function () {
            atcText.textContent = originalText;
            atcBtn.disabled = false;
          }, 2000);
        });
    });
  }

  function updateCartCount() {
    fetch('/cart.js', {
      headers: { 'Accept': 'application/json' }
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        // Try common cart count selectors
        var selectors = [
          '.site-header-cart--count',
          '[data-header-cart-count]',
          '.cart-count',
          '.header__cart-count',
          '#cart-icon-bubble span'
        ];
        selectors.forEach(function (sel) {
          var el = document.querySelector(sel);
          if (el) {
            el.textContent = cart.item_count;
            el.style.opacity = cart.item_count > 0 ? '1' : '';
            if (el.hasAttribute('data-header-cart-count')) {
              el.setAttribute('data-header-cart-count', cart.item_count);
            }
          }
        });
      })
      .catch(function () {});
  }

  /* ========================================
     Tabs
     ======================================== */
  function initTabs() {
    var tabContainer = document.querySelector('[data-product-details]');
    if (!tabContainer) return;

    var tabs = tabContainer.querySelectorAll('.fpd__tab');
    var panels = tabContainer.querySelectorAll('.fpd__panel');
    if (tabs.length === 0) return;

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var target = this.getAttribute('data-tab');

        // Update tabs
        tabs.forEach(function (t) {
          t.classList.remove('fpd__tab--active');
          t.setAttribute('aria-selected', 'false');
        });
        this.classList.add('fpd__tab--active');
        this.setAttribute('aria-selected', 'true');

        // Update panels
        panels.forEach(function (p) { p.classList.remove('fpd__panel--active'); });
        var panel = tabContainer.querySelector('[data-panel="' + target + '"]');
        if (panel) panel.classList.add('fpd__panel--active');
      });

      // Keyboard navigation
      tab.addEventListener('keydown', function (e) {
        var tabArr = Array.from(tabs);
        var idx = tabArr.indexOf(this);

        if (e.key === 'ArrowRight' && idx < tabArr.length - 1) {
          tabArr[idx + 1].focus();
          tabArr[idx + 1].click();
        } else if (e.key === 'ArrowLeft' && idx > 0) {
          tabArr[idx - 1].focus();
          tabArr[idx - 1].click();
        }
      });
    });
  }

  /* ========================================
     Helpers
     ======================================== */
  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function isTouchDevice() {
    return 'ontouchstart' in window || navigator.maxTouchPoints > 0;
  }

  /* ========================================
     Initialize
     ======================================== */
  document.addEventListener('DOMContentLoaded', function () {
    initGallery();
    initVariants();
    initQuantity();
    initAddToCart();
    initTabs();
  });
})();
